import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, getFormValues, change } from 'redux-form';
import { withRouter } from 'react-router';
import v from 'validate.js';
import styles from './style.module.css';
import * as Routes from '../../../../../constants/routes';
import { onSubmit } from '../../../../../common/components/submit-button';
import RenderInput from '../../../../../common/components/render-input';
import { trackingEvent } from '../../../../../helpers/tracking';

const tracking = {
    eventAction: 'Prosperity Planner - Step 1',
    eventLabel: 'Prosperity'
};

export const formName = Routes.STEPONE;

export const formDetails = {
    key: 'wordForProsperity',
    title: 'In one word, what does prosperity mean to you?',
    formName,
    totalKey: 'wordForProsperity',
    fields: {
        wordForProsperity: {
            label: 'In one word, what does prosperity mean to you?',
            placeholder: 'Wealth, Comfort, Security, etc',
            required: true
        }
    }
};

const minValue = '';

const validate = values => v(values, {
    [formDetails.totalKey]: {
        presence: {
            allowEmpty: false,
            message: 'is required'
        }
    }
});

class StepOneForm extends Component {
    componentDidUpdate() {
        const {
            props: {
                formValues,
                changeFieldValue
            }
        } = this;
        changeFieldValue(formDetails.totalKey, formValues[formValues.totalKey]);
    }

    render() {
        return (
            <form className={styles.form}>
                {
                    Object.keys(formDetails.fields).map(key =>
                        <Field
                            key={key}
                            type='text'
                            name={key}
                            label={formDetails.fields[key].label}
                            tooltip={formDetails.fields[key].tooltip}
                            component={RenderInput}
                            required={formDetails.fields[key].required}
                            placeholder={formDetails.fields[key].placeholder}
                        />
                    )
                }
            </form>
        );
    }
}

const formValues = getFormValues(formName);

const mapStateToProps = (state) => ({
    formValues: formValues(state),
    paginationSkipState: state.calculator.paginationHasSkip,
});

const mapDispatchToProps = (dispatch) => ({
    changeFieldValue: (field, value) => dispatch(change(formName, field, value))
});

StepOneForm = reduxForm({
    form: formName,
    destroyOnUnmount: false,
    validate,
    onSubmit,
    initialValues: Object.keys(formDetails.fields).reduce((obj, val) => ({
        ...obj,
        [val]: minValue
    }), {}),
    skipPath: `/prosperity-planner${Routes.SUMMARY}`,
    redirectPath: `/prosperity-planner${Routes.STEPTWO}`,
    tracking: () => trackingEvent(tracking)
})(StepOneForm);

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(StepOneForm));

